enum SponsorshipStatus {
    STARTING = 'starting',
    ENDING = 'ending',
}

export default SponsorshipStatus